import apiClient from 'api/tablelistApi'

export default {
  listByUserId(userId, options) {
    if (!userId) throw new Error('organizationId')
    if (!options) throw new Error('options')

    return apiClient.get(`/v1/users/${userId}/chat-messages`, options)
  },
  createByVenueIdAndUserId(venueId, userId, options) {
    if (!venueId) throw new Error('venueId')
    if (!userId) throw new Error('userId')
    if (!options) throw new Error('options')

    options.venueId = venueId

    return apiClient.post(`/v1/users/${userId}/chat-messages`, options)
  },
}



// WEBPACK FOOTER //
// ./src/api/chatMessage/service.js